import sancionesSolicitudService from '@/services/sancionesSolicitud.service.js';
import helper from './helper.js';

//test push
export default {
  namespaced: true,
  state: {
    tipoDocumento: [],
    tipoDocumentoSeleccionado: null,
    idNivelGravedadSeleccionado: null,
    buscarPersona: null,
    expedientePersona: null,
    datosPlaza: null,
    tipoReporte: null,
    faltaCometida: null,
    archivos: [],
    historial_sanciones: [],
  detalleResolucion: null,
    sancionesAplicadas: {
      tipoSancionId: null,
      montoPagar: null,
      porcentajeRebajaSalario: null,
      categoriaTemporal: null,
      numeroMesesPostergacion: null,
      fechaInicioSancion: null,
      fechaFinSancion: null,
    },
    nivelesGravedad: [
      {
        nombre: 'Falta leve',
        id: 1,
      },
      {
        nombre: 'Falta grave',
        id: 2,
      },
    ],
  },
  getters: {
    getBuscarPersona(state) {
      return state.buscarPersona;
    },
  },
  mutations: {
    setSancionesAplicadas(state, payload) {
      state.sancionesAplicadas = {
        tipoSancionId: payload?.tipoSancionId ?? null,
        montoPagar: payload?.montoPagar ?? null,
        porcentajeRebajaSalario: payload?.porcentajeRebajaSalario ?? null,
        categoriaTemporal: payload?.categoriaTemporal ?? null,
        numeroMesesPostergacion: payload?.numeroMesesPostergacion ?? null,
        fechaInicioSancion: payload?.fechaInicioSancion ?? null,
        fechaFinSancion: payload?.fechaFinSancion ?? null,
      };
    },
    setBuscarPersona(state, payload) {
      state.buscarPersona = payload;
    },
    setTipoDocumentoSeleccionado(state, payload) {
      state.tipoDocumentoSeleccionado = payload;
    },
    setExpedientePersona(state, payload) {
      state.expedientePersona = payload;
    },
    setTipoReporte(state, payload) {
      state.tipoReporte = payload;
    },
    setFaltaCometida(state, payload) {
      state.faltaCometida = payload;
    },
    setArchivos(state, payload) {
      state.archivos = payload;
    },
    setDatosPlaza(state, payload) {
      state.datosPlaza = payload;
    },
    setTipoDocumentos(state, payload) {
      state.tipoDocumento = payload;
    },
    setHistorialSanciones(state, payload) {
      // dar formato a la fecha de cada sancion 31/12/2025 sin utilizar librerias
      const sancionesConFormato = payload.map(sancion => {
        const fecha = new Date(sancion.fecha);
        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
        const anio = fecha.getFullYear();
        return {
          ...sancion,
          fecha: `${dia}/${mes}/${anio}`,
        };
      });

      state.historial_sanciones = sancionesConFormato;
    },
    setDetalleResolucion(state, payload) {
      state.detalleResolucion = payload || null;
    },
    setIdNivelGravedadSeleccionado(state, payload) {
      state.idNivelGravedadSeleccionado = payload;
    },
  },
  actions: {
    actualizarBuscarPersona({ commit }, persona) {
      commit('setBuscarPersona', persona);
    },
    actualizarTipoDocumentoSeleccionado({ commit }, tipoDocumento) {
      commit('setTipoDocumentoSeleccionado', tipoDocumento);
    },
    actualizarfaltaCometida({ commit }, faltaCometida) {
      commit('setFaltaCometida', faltaCometida);
    },

    // Expendiente de persona
    async fetchExpedientePersona({ state, commit, dispatch }) {
      const tipoDocumentoId = state.tipoDocumentoSeleccionado?.id || '';
      const numeroDocumento = state?.buscarPersona || '';
      commit('setExpedientePersona', null);
      dispatch('reiniciarEstados', false);
      try {
        // simular retardo
        //await new Promise(resolve => setTimeout(resolve, 2200));
        // llena el componenrte expedientePersona

        const response = await sancionesSolicitudService.fetchExpediente({
          tipoDocumentoId,
          numeroDocumento,
        });

        const data = response?.data || {};
        const expediente = data?.data || {};
        const datosPersonales = expediente?.datosPersonales;
        const datosPlaza = expediente?.datosPlaza || {};
        const historialSanciones = expediente?.historialSanciones || [];

        if (response?.status === 200) {
          // const expedientePersona =
          //   helper.mapExpedienteResponse(datosPersonales);
          commit('setExpedientePersona', datosPersonales);
          commit('setDatosPlaza', datosPlaza);
          // llenar tab de historial sanciones
          commit('setHistorialSanciones', historialSanciones);
        }
        return response;
      } catch (error) {
        commit('setExpedientePersona', null);
      }
    },

    // actualiza el array de los archivos para crear la sancion

    actualizarArchivos({ commit, state }, archivo) {
      // si es un array vacion asigna el valor de archivos a el array recibido
      if (Array.isArray(archivo) && archivo.length === 0) {
        commit('setArchivos', []);
        return;
      }

      const archivos = [...state.archivos, archivo];

      commit('setArchivos', archivos);
    },

    // eliminar un archivo del array de archivos

    eliminarArchivo({ commit, state }, archivoId) {
      const archivosActualizados = state.archivos.filter(
        archivo => archivo.id !== archivoId
      );
      commit('setArchivos', archivosActualizados);
    },

    // Asigna valores a select de tipo de reporte
    async fetchTipoReporte({ commit }, idEstado) {
      try {
        const estadoId = Number(idEstado);
        if (!Number.isInteger(estadoId) || estadoId <= 0) {
          commit('setTipoReporte', []);
          return;
        }

        const response = await sancionesSolicitudService.fetchTiposReporte(estadoId);
        const { data = [] } = response?.data || {};
        commit('setTipoReporte', data);
      } catch (error) {
        console.error('Error al obtener tipos de reporte:', error);
        commit('setTipoReporte', []);
      }
    },
    async fetchTipoDocumento({ commit }) {
      try {
        const response = await sancionesSolicitudService.fetchTipoDocumentos();
        const { data = [] } = response?.data || {};
        commit('setTipoDocumentos', data);
      } catch (error) {
        console.error('Error al obtener tipos de documento:', error);
        commit('setTipoDocumentos', []);
      }
    },

    async guardarSancion({ state }) {
      try {
        const faltaGrave = state.idNivelGravedadSeleccionado === 2 ? 1 : 0;

        const data = {
          empleadoPuestoId: state.expedientePersona.empleadoPuestoId,
          establecimientoId: state.expedientePersona.establecimientoId,
          faltaGrave,
          faltaCometida: state.faltaCometida,
          archivos: state.archivos,
        };

        //simular retardo
        //await new Promise(resolve => setTimeout(resolve, 2200));

        return await sancionesSolicitudService.guardarSancion(data);
      } catch (error) {
        console.error('Error en guardarSancion:', error);
        throw error;
      }
    },
    actualizarIdNivelGravedadSeleccionado({ commit }, tipoReporte) {
      commit('setIdNivelGravedadSeleccionado', tipoReporte);
    },

    reiniciarEstados({ commit }, all = true) {
      if (all) {
        commit('setTipoDocumentoSeleccionado', null);
        commit('setBuscarPersona', null);
      }
      commit('setExpedientePersona', null);
      // commit('setTipoReporte', null);
      commit('setFaltaCometida', null);
      commit('setArchivos', []);
      commit('setHistorialSanciones', []);
      commit('setIdNivelGravedadSeleccionado', null);
      commit('setDetalleResolucion', null);
    },
  },
};
